const PAGES = "pages";
module.exports = {
    PAGES
};
